import { AssessmentDistributionMemberData } from './assessment-distribution-member-data';
import { AssessmentMemberAnswer } from './assessment-member-answer';
import { CustomValue } from './custom-value';

export class AssessmentMemberData {
  isTemplate: boolean; // todo: doesn't seem to be return from server. remove.
  memberData: AssessmentDistributionMemberData;
  memberAnswers: Array<AssessmentMemberAnswer>;
  memberCustomValues: Array<CustomValue<any>>;
  template: boolean;
  contactID: any;
  deletedPersonnelID: any;
}
